import React from 'react';
import { PageHero } from '../components/PageHero';
import { Product as ProductSection } from '../components/Product';
import { PeriscanOperators } from '../components/PeriscanOperators';
import { Workflow } from '../components/Workflow';
import { FirstReport } from '../components/FirstReport';
import { Integrations } from '../components/Integrations';
import { Competitive } from '../components/Competitive';
import { SectionStage } from '../components/SectionStage';
import { FrontierGatewayTeaser } from '../components/FrontierGatewayTeaser';
export function Product() {
  return <>
      <PageHero eyebrow="Autonomous Security Validation" title="One platform." titleMuted="Continuous proof." description="A self-serve, agentless platform that finds the paths that matter, walks them safely, and proves what's actually exploitable. No sales calls, no enterprise rollout circus — just continuous proof." bg="none" data-id="element-1747" />
      <SectionStage fx="aurora-particles" data-id="element-1748">
        <ProductSection data-id="element-1749" />
      </SectionStage>

      {/* Periscan Operators — rendered without SectionStage so the cinematic
                      blur/opacity transform doesn't dampen the radar sweep behind it. */}
      <PeriscanOperators data-id="element-1750" />

      <SectionStage fx="orbit" data-id="element-1751">
        <FrontierGatewayTeaser data-id="element-1752" />
      </SectionStage>

      <SectionStage fx="circuit" data-id="element-1753">
        <Workflow data-id="element-1754" />
      </SectionStage>
      <SectionStage fx="beams-squares" data-id="element-1755">
        <FirstReport data-id="element-1756" />
      </SectionStage>
      <SectionStage fx="constellation" data-id="element-1757">
        <Integrations data-id="element-1758" />
      </SectionStage>
      <SectionStage fx="lightning" data-id="element-1759">
        <Competitive data-id="element-1760" />
      </SectionStage>
    </>;
}